import { gql } from "@apollo/client";

const COMBINED_FEED_CLIP_FIELDS = gql`
  fragment CombinedFeedClipFields on Clip {
    id
    shareId
    title
    thumbnailUrl(style: STANDARD)
    url(orientation: LANDSCAPE)
    createdAt
    type
    user {
      _id
      username
      avatarUrl
    }
  }
`;

export const COMBINED_FEED_QUERY = gql`
  ${COMBINED_FEED_CLIP_FIELDS}

  query CombinedFeed($limit: Int) {
    me {
      followingClips {
        ...CombinedFeedClipFields
      }
      playedWithClips {
        ...CombinedFeedClipFields
      }
      proPlayerClips {
        ...CombinedFeedClipFields
      }
    }
    shapedRecommendedClips: clipsRecommended(limit: $limit) {
      ...CombinedFeedClipFields
    }
  }
`;
